<template>
    <div class="list-box" v-loading="loading">
        <el-empty
            :description="i18n.tkey('lang_temporary_no_data')"
            v-show="dataList.length == 0"
        />

        <div v-if="dataList.length > 0">
            <el-row :gutter="15">
                <el-col
                    :span="cols"
                    v-for="(v, i) in dataList"
                    :key="v.id"
                    style="margin-bottom: 15px"
                >
                    <SponsorRecord
                        :obj="v"
                        @clickView="clickViewFunc"
                        @clickEdit="clickEditFunc"
                        @clickGoOrder="clickGoOrderFunc"
                    />
                </el-col>
            </el-row>

            <paginationComponent :pageObj="pageObj" @goPage="clickPageBtn" />
        </div>

    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount} from "vue";
import record14Api from "@/request/record14Api";
import myUtil from "@/util/util";
import paginationComponent from "@/components/shopopee/common/paginationComponent.vue"
import SponsorRecord from "@/components/shopopee/hall/sponsorRecord.vue";

const emits = defineEmits(["clickView", "clickEdit","clickGoOrder"])

const i18n = inject("i18n")
const loading = ref(false)
const cols = ref(24)

const dataList = ref([])
const pageObj = ref({})
let pageNum = 1
let pageSize = 10

const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

const shopCompany = ref({})

function getRecord14List(){
    loading.value = true

    const request = record14Api.getRecord14InfoPageByCompanycode
    const params = request.getParams()

    params.pageNum = pageNum
    params.pageSize = pageSize
    params.companycode = shopCompany.value.companycode

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            pageObj.value = res.detail
            dataList.value = res.detail.list
        }else{
            myUtil.alertError(res.msg)
        }

    })
}

function clickPageBtn(value){
    pageNum = value

    getRecord14List()

}

function clickViewFunc(obj){
    emits("clickView", obj)
}

function clickEditFunc(obj){
    emits("clickEdit", obj)
}

function clickGoOrderFunc(obj){

  emits("clickGoOrder", obj)
}

onBeforeMount(() => {
    if (!myUtil.isMobile()){
        cols.value = 12
    }

    shopCompany.value = getShopCompanyObj()

    getRecord14List()
})

</script>

<style scoped>
    .list-box {
        box-sizing: border-box;
        padding: 10px;
    }
</style>